<template>
  <div class="container" style="margin-top:40px">
    <div class="row">
      <div class="col-sm-6 col-md-5 col-md-offset-4 login-col">
        <div class="panel panel-default">
          <div class="panel-heading">
            <strong>Definir nova senha</strong>
          </div>
          <div class="panel-body">
            <form @submit.prevent="save()" class="registration-form" autocomplete="off">
              <fieldset>
                <div class="row">
                  <div class="col-sm-12 col-md-10 col-md-offset-1 login-col">
                    <div class="form-group">
                      <b-input-group>
                        <b-input-group-text slot="prepend">
                          <i class="material-icons">person</i>
                        </b-input-group-text>
                        <b-form-input v-model="email" placeholder="Seu e-mail" required disabled/>
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <b-input-group>
                        <b-input-group-text slot="prepend">
                          <i class="material-icons">lock</i>
                        </b-input-group-text>
                        <b-form-input
                          type="password"
                          v-model="password"
                          placeholder="Nova senha"
                          autocomplete="off"
                          required
                        />
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <b-input-group>
                        <b-input-group-text slot="prepend">
                          <i class="material-icons">lock</i>
                        </b-input-group-text>
                        <b-form-input
                          type="password"
                          v-model="repetaedPassword"
                          placeholder="Repita a nova senha"
                          autocomplete="off"
                          required
                        />
                      </b-input-group>
                    </div>
                    <div class="form-group">
                      <input
                        type="submit"
                        class="btn btn-lg btn-primary btn-block"
                        value="Alterar senha"
                      >
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormHeader from "../../components/shared/FormHeader.vue";
import FormButton from "../../components/shared/FormButton.vue";
import ChangePassword from "../../model/ChangePassword";
import GuideService from "../../service/GuideService";
import VueJwtDecode from "vue-jwt-decode";
import BlumarJwtDecode from '../../BlumarJwtDecode';


export default {
  components: {
    formheader: FormHeader,
    formbutton: FormButton
  },
  data() {
    return {
      email: "",
      password: "",
      repetaedPassword: ""
    };
  },
  created() {
    try {
      const decodedToken = BlumarJwtDecode.decode(this.$route.query.token);
      this.email = decodedToken.email;
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedToken.exp < currentTime) {
        throw new Error("Link expirado! Solicite novamente a recuperacao de senha.");
      }
    } catch (error) {
      this.$store.dispatch("showAlert", {
        message: error.message,
        code: 0,
        style: "danger",
      });
      setTimeout(() => {this.$router.push("/login");}, 3000);
    }
  },
  methods: {
    save() {
      if (this.password !== this.repetaedPassword) {
        this.$store.dispatch("showAlert", {
          message: "As senhas precisam sem iguais.",
          code: 0,
          style: "danger"
        });
        return;
      }

      const userService = new GuideService();
      userService
        .changePassword(
          new ChangePassword(this.$route.query.token, this.password)
        )
        .then(() => {
          this.$store.dispatch("showAlert", {
            message: "Senha alterada com sucesso.",
            code: 0,
            style: "success"
          });

          setTimeout(() => this.$router.push("/"), 3000);
        })
        .catch(error => {
          this.$store.dispatch("showAlert", {
            message: error.response.data.message,
            code: 0,
            style: "danger"
          });
        });
    }
  }
};
</script>

<style scoped>
.row {
  display: block;
}

.panel {
  margin-top: 100px;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
}

.panel-heading {
  padding: 5px 15px;
  text-align: center;
  background-color: #f5f5f5;
  border-color: #ddd;
  color: #163247 !important;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.panel-body {
  padding: 15px;
}

.col-md-offset-4 {
  left: 50%;
  transform: translate(-50%, 0);
}

.col-md-offset-1 {
  margin-left: 8.33333333%;
}

.login-col {
  padding-right: 3px !important;
  padding-left: 3px !important;
}

.profile-img {
  width: 98px;
  height: 69px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.btn-primary {
  background-color: #163247 !important;
  border-color: #042035 !important;
}

.btn-primary:hover {
  background-color: #042035 !important;
  border-color: #042035 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/change-password/ChangePassword.vue